// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e8e2lxHrTbqN7zvNF0xk {
  text-align: center;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
  font-size: 0;
}

.Gol5RCly83SGNJ3XvOFH {
  font-size: 100px;
}`, "",{"version":3,"sources":["webpack://./src/views/Eligible/Modal/ErrorCreateModal/ErrorCreateModal.module.css"],"names":[],"mappings":"AAGA;EACE,kBAAkB;EAClB,mDAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["@value colors: \"components/library/style/colors.css\";\n@value color-error from colors;\n\n.icon {\n  text-align: center;\n  color: color-error;\n  font-size: 0;\n}\n\n.materialIcons {\n  font-size: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"components/library/style/colors.css"`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"icon": `e8e2lxHrTbqN7zvNF0xk`,
	"materialIcons": `Gol5RCly83SGNJ3XvOFH`
};
export default ___CSS_LOADER_EXPORT___;
